<div class="payment-success-container">
  <div class="payment-success-card">
    <div class="icon-wrapper">
      <div class="spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
    </div>

    <h1 class="success-title">{{ 'priceUi.processingPaymentTitle' | translate }}</h1>
    <p class="success-message">
      {{ 'priceUi.processingPaymentMessage' | translate }}
    </p>

    <div class="progress-dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
  </div>
</div>
